export const SIGNUP = 'SIGNUP'